/* Forma de pago del carrito — dos trabajos, los dos opcionales.

   1) AVISO DE "LLEVÁNDOTE AL PAGO". Los formularios de sm-cart-pago.liquid ya
      funcionan solos: hacen POST a /cart/update con return_to=/checkout y
      Shopify aterriza directo en la pantalla de pago. Pero ese viaje tarda un
      segundo largo y sin aviso el cliente cree que no pasó nada y vuelve a
      clickear. Esto solo pinta el botón mientras tanto.

   2) LIMPIAR EL DESCUENTO PEGADO DE UNA VISITA ANTERIOR.
      Alguien que un día eligió transferencia y no compró, al volver se
      encontraba el 30% ya puesto sin haberlo pedido: veía un total que no le
      corresponde y podía terminar pagándolo con tarjeta.

      Son DOS pegamentos distintos y hay que despegar los dos:

      a) El carrito. Los cupones viven en el carrito, y el carrito es una cookie
         que dura días. Al abrir el carrito, si está el cupón de transferencia,
         se saca. Los DEMÁS se conservan: los de los packs (PACK-DUO,
         PACK-TOTAL…) no son un regalo, son el precio del pack.

      b) La cookie `discount_code`. ⚠️ MEDIDO el 2026-08-28 contra samana.ar:
         entrar por /discount/CODIGO deja esa cookie en el navegador, y al crear
         la pantalla de pago Shopify VUELVE A APLICAR el cupón aunque ya no esté
         en el carrito. Sacarlo del carrito solo no alcanza. La cookie no es
         HttpOnly, así que se puede borrar desde acá; hecho eso, el cupón ya no
         vuelve (medido). Por las dudas, el sitio dejó de usar /discount/ para
         poner cupones: ahora todo va por /cart/update (que no deja cookie).
         Solo se borran los cupones que pone el sitio, para no pisar un futuro
         link de promoción del estilo samana.ar/discount/LOQUESEA.

   MEDIDO el 2026-08-28 contra samana.ar:
     POST /cart/update.js  {"discount": ""}         → deja el carrito sin cupones
     POST /cart/update.js  {"discount": "A,B"}      → deja exactamente esos dos
   O sea: el campo "discount" REEMPLAZA la lista entera, no suma. Por eso siempre
   se manda la lista completa que tiene que quedar.

   Si algo de esto falla (sin conexión, respuesta rara), no se toca nada: los
   formularios siguen funcionando y el peor caso es el de antes. */

(function () {
  'use strict';

  if (window.__smPagoListo) return;
  window.__smPagoListo = true;

  var guion = document.getElementById('sm-cart-pago-js');
  var codigo = ((guion && guion.dataset.smCodigo) || '').trim();
  var textoCargando = (guion && guion.dataset.smCargando) || 'Llevándote al pago…';
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Cupones que pone el sitio solo. Son los únicos que este guión se permite
  // borrar de la cookie `discount_code`.
  var delSitio = ((guion && guion.dataset.smCuponesSitio) || '')
    .split(',')
    .map(function (c) { return c.trim().toLowerCase(); })
    .filter(Boolean);

  /* ---------- 1. Aviso mientras carga la pantalla de pago ---------- */

  // El escuchador va en el documento y no en cada formulario a propósito: al
  // cambiar cantidades, cart.js vuelve a dibujar esta sección entera y los
  // formularios pasan a ser otros nodos.
  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.matches || !form.matches('form[data-sm-pago]')) return;

    form.classList.add('sm-cp__op--cargando');

    var pie = form.querySelector('[data-sm-ir]');
    if (pie) pie.textContent = textoCargando;

    // El otro botón se apaga para que no salgan dos viajes al pago a la vez.
    var todos = document.querySelectorAll('form[data-sm-pago]');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i] !== form) todos[i].classList.add('sm-cp__op--apagada');
    }
  });

  /* ---------- 2. Despegar el descuento de una visita anterior ---------- */

  borrarCookieDeCupon();

  if (!codigo) return;

  fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (carrito) {
      if (!carrito || !carrito.discount_codes) return null;

      var puestos = carrito.discount_codes.filter(function (d) { return d.applicable; });
      var tieneTransfer = puestos.some(function (d) {
        return String(d.code).toLowerCase() === codigo.toLowerCase();
      });
      if (!tieneTransfer) return null;

      var quedan = puestos
        .filter(function (d) { return String(d.code).toLowerCase() !== codigo.toLowerCase(); })
        .map(function (d) { return d.code; });

      return fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: quedan.join(',') })
      }).then(function (r) { return r.ok ? true : null; });
    })
    .then(function (limpio) {
      if (limpio) redibujarCarrito();
    })
    .catch(function () { /* sin conexión o respuesta rara: se deja como está */ });

  /* Borra la cookie `discount_code` si guarda uno de los cupones que pone el
     sitio. Si no se borra, Shopify lo vuelve a aplicar al armar la pantalla de
     pago, por más que lo hayamos sacado del carrito (medido).
     Se borra en todas las variantes de dominio que puede tener la cookie,
     porque no se sabe con cuál la escribió Shopify. */
  function borrarCookieDeCupon() {
    if (!delSitio.length) return;

    var actual = '';
    try {
      var par = document.cookie.split(';').find(function (t) {
        return t.trim().indexOf('discount_code=') === 0;
      });
      if (par) actual = decodeURIComponent(par.trim().slice('discount_code='.length));
    } catch (e) { return; }

    if (!actual) return;
    if (delSitio.indexOf(actual.trim().toLowerCase()) === -1) return;

    var host = window.location.hostname;
    var dominios = ['', host, '.' + host];
    var puntos = host.split('.');
    if (puntos.length > 2) dominios.push('.' + puntos.slice(-2).join('.'));

    dominios.forEach(function (d) {
      document.cookie =
        'discount_code=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        (d ? '; domain=' + d : '');
    });
  }

  /* Vuelve a pedirle a Shopify las secciones del carrito y las reemplaza en el
     lugar, para no tener que recargar la página (que es justamente lo que se
     quiso sacar de encima). Se apoya en el mismo mecanismo que usa cart.js:
     el id del <div> para encontrarlo en la página y su data-id para pedírselo
     a Shopify (en las plantillas .json no son lo mismo). */
  function redibujarCarrito() {
    var candidatas = ['main-cart-items', 'main-cart-footer', 'sm-cart-pago'];
    var partes = [];

    candidatas.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) partes.push({ id: id, seccion: el.dataset.id });
    });
    if (!partes.length) return;

    var url = raiz + 'cart?sections=' + partes.map(function (p) { return p.seccion; }).join(',');

    // ⚠️ SIN cabecera Accept: con `Accept: application/json`, /cart devuelve el
    // carrito en JSON y se ignora el ?sections=. Sin ella devuelve el HTML de
    // cada sección, que es lo que hace falta acá. (Medido el 2026-08-28.)
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (secciones) {
        if (!secciones) return;
        partes.forEach(function (p) {
          var html = secciones[p.seccion];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('#' + p.id + ' .js-contents') || doc.querySelector('.js-contents');
          var viejo = document.querySelector('#' + p.id + ' .js-contents');
          if (nuevo && viejo) viejo.innerHTML = nuevo.innerHTML;
        });
      })
      .catch(function () { /* si no se pudo redibujar, los importes quedan viejos
                              hasta que el cliente toque algo: molesto, no roto */ });
  }
})();
